/**
 * Template Component
 */

import React, { FC } from 'react';
import { withTheme } from 'styled-components';
import { TemplateProps } from './template.types';
import Skeleton from '../Skeleton/skeleton';
import { Content, Wrapper } from './template.style';

const Template: FC<TemplateProps> = ({
  headline,
  type,
  theme = {},
  isLoading
}: TemplateProps) => {
  const { dark, teamColor1 } = theme;

  const TemplateContent = isLoading
    ? <Skeleton width={ 100 } height={ 15 } />
    : (
      <Content
        dark={ dark }
        teamColor1={ teamColor1 }
        type={ type }
      >
        { headline }
      </Content>
    );

  return (
    <Wrapper>
      { TemplateContent }
    </Wrapper>
  );
};

export default withTheme(Template);
